__webpack_require__.p = "https://beta.in.safer.whs.amazon.dev/";